 // Scripting to handle tabs interaction
(function($){

  //Stop propagation on linked card anchor clicks
  $(document).on('click', '.card.linked-card a, .card.no-excerpt a', function(e) {
  //$('.card.linked-card a, .card.no-excerpt a').click(function(e) {
    e.preventDefault();
  });

  //Capture card clicks outside of the anchors
  $(document).on('click', '.card.linked-card', function(e) {
  //$('.card.linked-card').click(function(e) {
    let $card = $(this).hasClass('card') ? $(this) : $(this).parents('.card');
    let $anchor = $card.find('a').first();

    if ($anchor) {
      handleCardAnchorClick($anchor);
    }

  });

  //Capture card clicks outside of the anchors
  $(document).on('click', '.card.no-excerpt', function(e) {
  //$('.card.no-excerpt').click(function(e) {
    let $card = $(this).hasClass('card') ? $(this) : $(this).parents('.card');
    let $anchor = $card.find('a').first();

    if ($anchor) {
      handleCardAnchorClick($anchor);
    }

  });


  //Stop propagation on linked related resource anchor clicks
  $(document).on('click', '.archive-item.related-resource a', function(e) {
  //$('.archive-item.related-resource a').click(function(e) {
    e.preventDefault();
  });

  //Capture card clicks outside of the anchors
  $(document).on('click', '.archive-item.related-resource', function(e) {
  //$('.archive-item.related-resource').click(function(e) {
    let $card = $(this).hasClass('archive-item') ? $(this) : $(this).parents('.archive-item');
    let $anchor = $card.find('a').first();

    if ($anchor) {
      handleCardAnchorClick($anchor);
    }

  });


  //Capture card clicks outside of the anchors
  $(document).on('click', '.card.linked-resource', function() {
  //$('.card.linked-card').click(function(e) {
    let $card = $(this).hasClass('card') ? $(this) : $(this).parents('.card');
    let $anchor = $card.find('a').first();

    if ($anchor) {
      handleCardAnchorClick($anchor);
    }

  });


 // Media/Text Blocks -  Probably not the best place to put this, but for now.. This is for the Child Pages Shortcode
  $('.media-text-group .wp-block-media-text:even').addClass("has-media-on-the-right");



  //Centralized handling of the card clicks
  function handleCardAnchorClick($anchor) {
    //Modals have to trigger a special event to avoid recursive clicking
    if ($anchor.hasClass('open-popup-link')) {
      $anchor.trigger('modalclick');
    }
    else if ($anchor.attr('target') == '_blank') {
      window.open($anchor.attr('href'));
    }
    else {
      window.location = $anchor.attr('href');
    }
  }

})(jQuery);
